import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: () => import('@/views/Index.vue'),
  children: [
    {
      path: '',
      name: 'Home',
      component: () => import('@/views/home/Home.vue')
    },
    {
      path: 'join',
      name: 'Join',
      component: () => import('@/views/join/Join.vue')
    },
    {
      path: 'service',
      name: 'Service',
      component: () => import('@/views/service/Service.vue')
    },
    {
      path: 'partners',
      name: 'Partners',
      component: () => import('@/views/partners/Partners.vue')
    },
      {
          path: 'taobaoAlliance',
          name: 'taobaoAlliance',
          component: () => import('@/views/taobao/Taobao.vue')
      },

  ],
},
{
  path: '*',
  name: '*',
  component: () => import('@/components/Error.vue')
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// router.beforeEach((to, from, next) => {
//   // to: Route: 即将要进入的目标 路由对象
//   // from: Route: 当前导航正要离开的路由
//   // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
//   const permissionList = store.getters.userInfo.permissionList; // 被许可的路由地址数组
//   const Token = localStorage.getItem('Token'); // 登录token
//   if(to.name != 'login' && to.name != 'error'  ){//非登录页 非错误页
//     if (Token) {//有token
//       if(to.path!='/' && !permissionList.includes(to.path)){ //非首页 && 没有有路由地址许可
//         next({name:'error'});//跳转error页
//       }
//     }else{
//       next({name: 'login'})//跳转登录页
//     }
//   }
//   next();
// });
export default router
